import { useState, useEffect } from 'react';

const useTenFreeDeliveryProducts = () => {
  const [tenFreeDeliveryProducts, setTenFreeDeliveryProducts] = useState([]);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTenFreeDeliveryProducts = async () => {
      try {
        // const response = await fetch(`/api/getAllProduct`);
        const response = await fetch(`https://backend.nuhababy.com/getTenFreeDeliveryProduct`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setTenFreeDeliveryProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTenFreeDeliveryProducts();
  }, []);

  return { tenFreeDeliveryProducts, loading1, error };
};

export default useTenFreeDeliveryProducts;